import React from 'react';
import { observer } from 'mobx-react-lite';
import { GapSizeType } from '../../../../../theme/type/gap-type';
import { cn, marginBottomClass, marginTopClass } from '../../../../../utils/tailwind';

type AgreeType = {
    children: React.ReactNode;
    marginTop?: GapSizeType;
    marginBottom?: GapSizeType;
};

export const Agree: React.FC<AgreeType> = observer(
    ({ children, marginTop = 'none', marginBottom = 'none' }: AgreeType) => {
        return (
            <div
                className={cn(
                    'flex flex-col items-center [&_a]:text-brand-secondary [&_a]:underline [&_a]:transition-all hover:[&_a]:text-[#6A6FF9] hover:[&_a]:no-underline',
                    marginTopClass[marginTop],
                    marginBottomClass[marginBottom],
                )}
            >
                {children}
            </div>
        );
    },
);
